import { ResponseHeader } from "./ResponseHeader"

/**
 * Extracts filename from Content-Disposition header.
 *
 * Parses filename parameter from Content-Disposition response header.
 *
 * @param r - Request, Response, or XMLHttpRequest object
 * @param name - Default filename if not found in header
 * @returns Filename from header or default
 *
 * @example
 * ```ts
 * import { ResponseFileName } from "@pdfking/tfunc"
 *
 * const filename = ResponseFileName(response, "download.pdf")
 * // Returns "document.pdf" from "attachment; filename=document.pdf"
 * ```
 */
export const ResponseFileName = (
  r: Request | Response | XMLHttpRequest,
  name: "file"
) => {
  // supports both fetch and xhttp

  const h = ResponseHeader(r, "content-disposition", "")

  try {
    return h.split("filename=")[1].split(";")[0]
  } catch {
    return name
  }
}
